export default __webpack_public_path__ + "static/media/logo-white-on-dark.431ede70.svg";